import { atom } from 'recoil';
import { config } from '../config';

const theme = localStorage.getItem(config.themeStorageKey) || 'light';

export const themeState = atom<string>({
  key: 'themeState',
  default: theme,
});
